<template>
	<div>
		<section class="course-desc py-4 pt-5">
			<div class="container py-3 pb-0">
				<h3 class="heading mb-4 pb-2 pt-2">让机器人陪伴中国儿童成长</h3>
				<h4 class="heading mb-4 pb-3">借助于专业教具，通过积木搭建出机器人外观，编程实现机器人的功能，将创意变成实物</h4>
				<ul class="clearfix">
					<li class="groupli1 fl">
						<img src="../../../assets/img/growup1.jpg" alt="">
						<p>搭建</p>
					</li>
					<li class="groupli2 fl">
						<img src="../../../assets/img/growup2.jpg" alt="">
						<p>编程</p>
					</li>
					<li class="fl">
						<img src="../../../assets/img/growup3.jpg" alt="">
						<p>锻炼能力</p>
					</li>
				</ul>
			</div>
		</section>
		<section class="course-desc bg-light py-5">
			<div class="container py-md-3">
				<h3 class="heading mb-4 pb-2 pt-2">小学到高中，完整的课程体系</h3>
				<h4 class="heading mb-4 pb-3">创造力培养 / 科技控制 / 智能机械</h4>
				<div class="row process-grids">
					<div class="col-lg-12 col-md-12">
						<div class="mt-3 mb-3" style="text-align: center;">
							<img src="../../../assets/img/fitage.png" alt="" class="img-fluid" />
						</div>
					</div>
				</div>
			</div>
		</section>
		<section class="course-desc py-5">
			<div class="container py-md-3">
				<h3 class="heading mb-4 pb-2 pt-1">机器人等级考试对升学有什么影响</h3>
				<h4 class="heading2 mb-1">在《中国制造2025》国家战略的引导下，机器人特长生已经在国内众多重点高中、重点高校得到优先选拔。中国电子学会通过与北京大学、清华大学、北京航空航天大学等十几所顶尖院校达成青少年机器人人才培训和选拔合作，为更多青少年的成长、成材开拓了广阔空间。</h4>
				<div class="row process-grids mb-3">
					<div class="col-lg-12 col-md-12">
						<div class="mt-3 mb-5" style="text-align: center;">
							<img src="../../../assets/img/robot001.jpg" alt="" class="img-fluid" />
							<img src="../../../assets/img/robot002.jpg" alt="" class="img-fluid" />
						</div>
						<div class="mt-3 mb-3" style="text-align: center;">
							<img src="../../../assets/img/robot003.jpg" alt="" class="img-fluid mr-4" />
							<img src="../../../assets/img/robot004.jpg" alt="" class="img-fluid" />
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	export default {
		name: 'IndexContent',
		methods: {},
		mounted() {}
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/css/robot/components/IndexContent.scss';
</style>